import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ContractDocumentResponseSchema } from '../../../common/generated/residentApiSchemas'

import { get } from 'api/apiClient'

export const useAPIGetContractDocumentInfo = (contractUuid: string) => {
  const apiEndpointUrl = API_ENDPOINTS.CONTRACT_DOCUMENT_INFO.replace(
    ':uuid',
    contractUuid
  )

  return useQuery({
    queryKey: [apiEndpointUrl],
    queryFn: () => get(apiEndpointUrl, ContractDocumentResponseSchema),
    // A failure deliberately only hides the contract document section, without an error
    // message: the error does not tell whether a document even exists (e.g. Docue / M-Files
    // being unreachable), and the user has not clicked anything yet
    throwOnError: false,
  })
}
